import React, { useEffect, useState } from "react";
import "./ShopByColor.css";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Icons from "../../../../Config/Images";
import { useNavigate } from "react-router-dom";
import CustomImageComponent from "../../CustomComponents/CustomImageComponent";
import { useMediaQuery } from "@mui/material";

const itemsPerPage = 4; // Adjust this based on how many items you want to show at once

const ShopByColor = ({ data }) => {
  const navigate = useNavigate();
  const [metal, setMetal] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  // Screen size queries
  const is1650SmallScreen = useMediaQuery("(max-width:1650px)");
  const is1450SmallScreen = useMediaQuery("(max-width:1450px)");
  const is600SmallScreen = useMediaQuery("(max-width:600px)");
  const is400SmallScreen = useMediaQuery("(max-width:400px)");

  // Screen size mappings
  const screenSizes = {
    imageHeight: {
      is400SmallScreen: "234px",
      is600SmallScreen: "244px",
      is1450SmallScreen: "340px",
      is1650SmallScreen: "390px",
      default: "414px",
    },
    cardHeight: {
      is400SmallScreen: "340px",
      is600SmallScreen: "350px",
      is1450SmallScreen: "450px",
      is1650SmallScreen: "500px",
      default: "525px",
    },
  };

  // Function to determine height based on screen size
  const getHeight = (sizes) => {
    if (is400SmallScreen) return sizes.is400SmallScreen;
    if (is600SmallScreen) return sizes.is600SmallScreen;
    if (is1450SmallScreen) return sizes.is1450SmallScreen;
    if (is1650SmallScreen) return sizes.is1650SmallScreen;
    return sizes.default;
  };

  // Calculating heights
  const imageHeight = getHeight(screenSizes.imageHeight);
  const cardHeight = getHeight(screenSizes.cardHeight);

  // Update the state when `data` prop changes
  useEffect(() => {
    if (data) {
      setMetal(data);
    }
  }, [data]);

  const handleIndividualMetal = (metalId, metalName) => {
    navigate(`/shop-by-color/${metalName}`, {
      state: { metalId: metalId, metalName: metalName, fromProductMetal: true },
    });
  };

  const handlePrevClick = () => {
    // setCurrentIndex((prevIndex) => Math.max(prevIndex - itemsPerPage, 0));
    setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  const handleNextClick = () => {
    setCurrentIndex((prevIndex) =>
      // Math.min(prevIndex + itemsPerPage, metal.length - itemsPerPage)
      Math.min(prevIndex + 1, metal.length - itemsPerPage)
    );
  };

  // Handle window resize to update window width
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const displayedMetals =
    windowWidth > 1200
      ? metal.slice(currentIndex, currentIndex + itemsPerPage)
      : metal; // Show all items below 1200px

  return (
    <div className="shopByColorDiv">
      <div className="headingContent">
        <h1>Shop by Metal</h1>
      </div>
      {windowWidth > 1200 && displayedMetals?.length > 3 && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            position: "absolute",
            top: "50%",
            left: "35px",
            // transform: "translateY(-50%)",
            // left: "50%",
            cursor: "pointer",
            zIndex: 9999,
          }}
          onClick={handlePrevClick}
        >
          <img
            style={{ height: "50px" }}
            src={Icons.leftSliderArrowIcon}
            alt=""
          />
        </div>
      )}
      <div className="lowerContent-metal">
        <div className="hrLine"></div>

        <div className="sliderControls-metal">
          {/* {windowWidth > 1200 && (
            <div
            style={{backgroundColor:"gray"}}
              className={`arrow-metal leftArrow-metal ${
                currentIndex === 0 ? "disabled" : ""
              }`}
              onClick={handlePrevClick}
            >
              <img className="arrow-img" src={Icons.leftSliderArrowIcon} alt="left arrow" />
            </div>
          )} */}

          <div className="cardsMainDiv">
            {displayedMetals.map((color, index) => (
              <Card
                key={index}
                className="card"
                sx={{
                  height: cardHeight,
                  // height: "525px",
                  // height:525,
                  position: "relative",
                  boxShadow: "none",
                  cursor: "pointer",
                  width: "400px",
                  // bgcolor:"yellow",
                  // border: "1px solid gray",
                }}
                onClick={() =>
                  handleIndividualMetal(
                    color.product_metal_id,
                    color.product_metal_name
                  )
                }
              >
                {/* <CardMedia
                component="img"
                height="414"
                image={color?.product_metal_images?.[0]?.product_metal_image_url}
                alt={color.product_metal_name}
              /> */}
                <CustomImageComponent
                  src={color?.product_metal_storage_url}
                  alt={color.product_metal_name}
                  fallbackSrc={Icons.blank_image}
                  // height="414px"
                  height={imageHeight}
                  width={"100%"}
                  // width="414px"
                />
                {/* <img style={{height:"414px"}} src={color?.product_metal_images?.[0]?.product_metal_image_url} alt="" /> */}
                <CardContent>
                  <div className="arrowCircleDiv">
                    <img
                      className="arrowCircleImg"
                      src={Icons.arrowCircleRightImage}
                      alt="arrow icon"
                    />
                  </div>
                  <div className="colorLabel">
                    <p>{color.product_metal_name}</p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* {windowWidth > 1200 && (
            <div
            style={{backgroundColor:"gray"}}
              className={`arrow-metal rightArrow-metal ${
                currentIndex + itemsPerPage >= metal.length ? "disabled" : ""
              }`}
              onClick={handleNextClick}
            >
              <img className="arrow-img" src={Icons.rightSliderArrowIcon} alt="right arrow" />
            </div>
          )} */}
        </div>
      </div>
      {windowWidth > 1200 && displayedMetals?.length > 3 && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            position: "absolute",
            top: "50%",
            // transform: "translateY(-50%)",
            right: "35px",
            cursor: "pointer",
          }}
          onClick={handleNextClick}
        >
          <img
            style={{ height: "50px" }}
            src={Icons.rightSliderArrowIcon}
            alt="right arrow"
          />
        </div>
      )}
    </div>
  );
};

export default ShopByColor;
